import type IDeviceStorage from 'lib/Interfaces/IDeviceStorage';

export const isDeviceStorage = (disclosure: unknown): disclosure is IDeviceStorage => {
  if (typeof disclosure !== 'object' || disclosure === null) {
    return false;
  }

  const t = disclosure as IDeviceStorage;

  return (
    (typeof t.id === 'string' || typeof t.id === 'number') &&
    typeof t.identifier === 'string' &&
    typeof t.type === 'string' &&
    typeof t.name === 'string' &&
    typeof t.maxAgeSeconds === 'string' &&
    typeof t.domain === 'string'
  );
};

export const isDeviceStorageArray = (disclosures: unknown): disclosures is IDeviceStorage[] => {
  if (!Array.isArray(disclosures)) {
    return false;
  }

  return disclosures.every((disclosure) => isDeviceStorage(disclosure));
};
